import { render, staticRenderFns } from "./GameOthers.vue?vue&type=template&id=7cae85d0"
import script from "./GameOthers.vue?vue&type=script&lang=js"
export * from "./GameOthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports